module.exports = __webpack_public_path__ + "fonts/04642c62a9d06e06ac7a3bfd96736bbf.svg";